import React, { useMemo } from 'react';
import {
  dateValidatorByFormat,
  Field,
  FieldTypes,
  Inscription,
} from '@common-fe/common-fe';
import dayjs from 'dayjs';
import * as yup from 'yup';

import { DATE_INVALID_TEXT, DEFAULT_DATE_FORMAT, REQUIRED_TEXT } from '@/common/constants';

export const usePlanTerminationDateForm = (
  dateValue?: string,
  minDate?: string,
  viewMode?: boolean,
  isExternalError?: boolean,
) => {
  const fields = useMemo(() => [
    {
      name: 'terminationDate',
      type: viewMode ? FieldTypes.Node : FieldTypes.Date,
      label: viewMode ?(
        <Inscription weight={400}>
          Termination date
        </Inscription>
      ) : 'Termination date',
      placeholder: 'Select date',
      isManualDateInput: true,
      showRequireIcon: !viewMode,
      controlStyles: { width: '160px' },
      inputWrapCssClass: 'small-input',
      validator: yup.string()
        .test({
          test: (val) => val ? dateValidatorByFormat(val, DEFAULT_DATE_FORMAT) : true,
          message: DATE_INVALID_TEXT, 
        })
        .required(REQUIRED_TEXT),
      isError: isExternalError,
      defaultValue: dateValue,
      value: viewMode ? (
        <Inscription color="textBody" weight={700}>
          {dateValue}
        </Inscription>
      ) : dateValue,
      minDate: minDate ? dayjs(minDate) : undefined,
      maxDate: dayjs().add(6, 'month'),
    },
  ], [
    dateValue,
    minDate,
    viewMode,
    isExternalError,
  ]);

  return fields as Field[];
};
